import React from 'react';
import {
	useTermItemsQuery,
	useUserNotificationSettingsQuery,
} from '../../../graphql/graphql';
import Loading from '../../../Components/Loading';
// @ts-ignore
import styles from './NotificationsSetup.module.scss';
import NotificationSetupItem from './NotificationSetupItem';
import { useAppContext } from '../../../Services/AppContext';

const NotificationsSetup: React.FC = () => {
	const { userData } = useAppContext();
	const { data: termItemsData, isLoading: termItemsIsLoading } =
		useTermItemsQuery({ termType: 'user_notifications' });
	const {
		data: settingData,
		isLoading: settingIsLoading,
		refetch: reFetchSetting,
	} = useUserNotificationSettingsQuery({ where: { userId: userData.id } });

	if (termItemsIsLoading || settingIsLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			{termItemsData?.termItems?.data?.map(item => {
				if (item && item.name && item.id) {
					return (
						<NotificationSetupItem
							name={item.name}
							id={item.id}
							isChecked={
								settingData?.userNotificationSettings?.data?.find(
									setting => setting?.typeTermItemId === item.id,
								)?.sending ?? false
							}
							onChange={reFetchSetting}
						/>
					);
				}
			})}
		</div>
	);
};

export default NotificationsSetup;
